"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatchingAssets = void 0;
const client_1 = require("@apollo/client");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const __1 = require("../..");
function useMatchingAssets(searchString) {
    const res = client_1.useQuery(QUERY, {
        variables: {
            locationId: __1.useLocationId(),
            searchString,
        },
        fetchPolicy: 'cache-first',
        skip: searchString.length < 3,
    });
    return res;
}
exports.useMatchingAssets = useMatchingAssets;
const QUERY = graphql_tag_1.default `
  query SearchAssetsQuery($locationId: String!, $searchString: String!) {
    location(locationId: $locationId) {
      key
      units(search: $searchString, filter: { name: kiraAssetType, type: any }) {
        list {
          key
          name
          unitAddress {
            key
            did
          }
        }
      }
    }
  }
`;
//# sourceMappingURL=useMatchingAssets.js.map